import { css } from '@emotion/react';

import {
  Button,
  COLOR_PALETTE,
  Flex,
  type FlexProps,
  Text,
  Title,
  desktopFirstMediaQuery,
} from '@inflearn/ds-react-next';

export const SETTINGS_ROW_GAP = 8;

const SETTINGS_PADDING = {
  desktop: 32,
  mobile: 24,
};

export const SettingSection = ({
  title,
  children,
}: {
  title?: string;
  children: React.ReactNode;
} & FlexProps) => (
  <Flex
    pos="relative"
    component="section"
    direction="column"
    w="100%"
    gap={16}
    py={SETTINGS_PADDING.desktop}
    px={SETTINGS_PADDING.desktop}
    styles={{
      root: styleSection,
    }}
  >
    {title !== undefined && (
      <Flex gap={8} w="100%">
        <Title
          order={2}
          c="gray.9"
          size={18}
          fw={700}
          styles={{
            root: { flex: '1 1 auto' },
          }}
        >
          {title}
        </Title>
      </Flex>
    )}
    <Flex direction="column" gap={SETTINGS_ROW_GAP}>
      {children}
    </Flex>
  </Flex>
);

SettingSection.Button = function SettingSectionButton({
  title,
  description,
  right,
  onClick,
}: {
  title: string;
  description: string;
  right: React.ReactNode;
  onClick?: () => void;
}) {
  return (
    <Button
      variant="white"
      w="100%"
      h={91}
      py={24}
      px={32}
      onClick={onClick}
      styles={{
        root: {
          height: 'unset',
          ...styleSection,

          '&:active, &:hover': {
            backgroundColor: COLOR_PALETTE.gray[0],
          },

          [desktopFirstMediaQuery.mobile]: { padding: 24 },
        },
        inner: { width: '100%' },
        label: {
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      }}
    >
      <Flex direction="column" align="flex-start">
        <Text size="md" fw={700} c="gray.9">
          {title}
        </Text>
        <Text size="sm" fw={500} c="gray.6">
          {description}
        </Text>
      </Flex>
      {right}
    </Button>
  );
};

SettingSection.TopRightSection = function SettingSectionTopRightSection({
  children,
  ...props
}: {
  children: React.ReactNode;
} & FlexProps) {
  return (
    <Flex
      pos="absolute"
      top={{
        base: SETTINGS_PADDING.mobile,
        sm: SETTINGS_PADDING.desktop,
      }}
      right={{
        base: SETTINGS_PADDING.mobile,
        sm: SETTINGS_PADDING.desktop,
      }}
      {...props}
    >
      {children}
    </Flex>
  );
};

const styleSectionBorder = css({
  border: `1px solid ${COLOR_PALETTE.gray[3]}`,
  borderRadius: '16px',
});

const styleSection = css([
  styleSectionBorder,
  {
    [desktopFirstMediaQuery.mobile]: {
      padding: SETTINGS_PADDING.mobile,
    },
  },
]);
